import MainPageCommonService from "../../../../services/main-page/MainPageCommonService";
import MainPageSecondScreenCommon from "./MainPageSecondScreenCommon";

export default class MainPageSecondScreenDesktop extends MainPageCommonService {
    private readonly $holder: JQuery;

    public readonly $screen: JQuery;
    public readonly $screenContainer: JQuery;
    public readonly $topContent: JQuery;
    public readonly $bottomContent: JQuery;
    public readonly $innerCenterPoint: JQuery;
    public readonly $cards: JQuery;

    public readonly SCALE_COEFFICIENT: number = 5;
    public readonly STARTED_SCALE_COEFFICIENT: number = 1;

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;

        const selectors = MainPageSecondScreenCommon.selectors;
        this.$screen = this.$holder.find(selectors.screen);
        this.$screenContainer = this.$screen.find(selectors.screenContainer);
        this.$topContent = this.$screenContainer.find(selectors.topContent);
        this.$bottomContent = this.$screenContainer.find(selectors.bottomContent);
        this.$innerCenterPoint = this.$screenContainer.find(selectors.innerCenterPoint);
        this.$cards = this.$screenContainer.find(selectors.cards);
    }
}
